module.exports = __webpack_public_path__ + "media/images/como_funciona/tutorial-buy-d8b275f9336935231af168c79b609e51.svg";